import { render, staticRenderFns } from "./articleTab.vue?vue&type=template&id=309510fe&scoped=true"
import script from "./articleTab.vue?vue&type=script&lang=js"
export * from "./articleTab.vue?vue&type=script&lang=js"
import style0 from "./articleTab.vue?vue&type=style&index=0&id=309510fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309510fe",
  null
  
)

export default component.exports